import React, { useEffect, useState } from "react";
import { PatternBackground } from "../../components/PatternBackground";
import { TwoTextCard } from "../../components/TwoTextCard";
import { ModalDialog } from "../../components/ModalDialog";
import { PopupModal } from "../../components/PopupModal";
import { serverRequest } from "../../util/server_request";
import { Spin } from "antd";
import { isFormComplete, logout, notifyUser } from "../../util/util";
import { useNavigate } from "react-router-dom";

export const ProfilePage = () => {
  const navigate = useNavigate();

  const [isPMOpen, setIsPMOpen] = useState(false);
  const [isCPOpen, setIsCPOpen] = useState(false);
  const [isRPOpen, setIsRPOpen] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [passwordForm, setPasswordForm] = useState({
    password: "",
    confirmPassword: "",
    oldPassword: "",
  });
  const [pinForm, setPinForm] = useState({
    newPin: "",
    confirmNewPin: "",
    oldPin: "",
  });
  const [pinResetForm, setPinResetForm] = useState({
    newPin: "",
    confirmNewPin: "",
    otp: "",
  });
  const [profile, setProfile] = useState({});
  const [isLoadingProfile, setIsLoadingProfile] = useState("");
  const [isLoadingPassword, setIsLoadingPassword] = useState("");
  const [isLoadingPin, setIsLoadingPin] = useState("");
  const [isVerifiedOTPPin, setIsVerifiedOTPPin] = useState(false);
  const [passwordType, setPasswordType] = useState("password");
  const togglePasswordType = () => {
    if (passwordType === "password") {
      setPasswordType("text");
    } else {
      setPasswordType("password");
    }
  };

  const togglePasswordModal = () => setIsPMOpen((prevState) => !prevState);
  const toggleChangePINModal = () => setIsCPOpen((prevState) => !prevState);
  const toggleResetPINModal = () => {
    if (!isRPOpen) {
      triggerOTP();
      setIsVerifiedOTPPin(true);
    }
    setIsRPOpen((prevState) => !prevState);
  };
  const toggleConfirmModal = () => setConfirmModal((prevState) => !prevState);
  const toggleIsLoadingProfile = () =>
    setIsLoadingProfile((prevState) => !prevState);
  const toggleIsLoadingPassword = () =>
    setIsLoadingPassword((prevState) => !prevState);
  const toggleIsLoadingPin = () => setIsLoadingPin((prevState) => !prevState);

  const criteria = {
    minLength: passwordForm.password.length >= 8,
    hasUppercase: /[A-Z]/.test(passwordForm.password),
    hasSpecialChar: /[!@#$%^&*(),.?":{}|<>]/.test(passwordForm.password),
    hasNumber: /\d/.test(passwordForm.password),
  };

  const changePasswordHandler = (e) =>
    setPasswordForm({ ...passwordForm, [e.target.name]: e.target.value });
  const changePinHandler = (e) =>
    setPinForm({ ...pinForm, [e.target.name]: e.target.value });
  const changePinResetHandler = (e) =>
    setPinResetForm({ ...pinResetForm, [e.target.name]: e.target.value });

  useEffect(() => {
    const fetchUserProfile = () => {
      toggleIsLoadingProfile();
      serverRequest("GET", "profile/details")
        .then((result) => {
          if (result?.success) {
            setProfile(result.data);
            toggleIsLoadingProfile();
          }
        })
        .catch((error) => {
          toggleIsLoadingProfile();
          notifyUser("error", error.message, "User Profile");
        });
    };
    
    fetchUserProfile();
  }, []); // fetchUserProfile is now defined inside useEffect

  // const refreshProfile = () => {
  //   toggleIsLoadingProfile();
  //   serverRequest("GET", "profile/details")
  //     .then((result) => {
  //       if (result?.success) {
  //         setProfile(result.data);
  //         toggleIsLoadingProfile();
  //       }
  //     })
  //     .catch((error) => {
  //       toggleIsLoadingProfile();
  //       notifyUser("error", error.message, "User Profile");
  //     });
  // };

  const submitChangePassword = () => {
    const isValid = Object.values(criteria).every(Boolean);
    if (isValid) {
      if (passwordForm.password !== passwordForm.confirmPassword) {
        return notifyUser(
          "error",
          "New Password must match confirmation password",
          "Validation Error"
        );
      }
      toggleIsLoadingPassword();
      const payload = {
        oldPassword: passwordForm.oldPassword,
        newPassword: passwordForm.password,
        confirmNewPassword: passwordForm.confirmPassword,
      };
      serverRequest("PUT", "users/password/change", payload).then((result) => {
        toggleIsLoadingPassword();
        if (result?.success) {
          notifyUser(
            "success",
            "Password changed successful. Login with new password!",
            "Password Changed"
          );
          logout();
          navigate("/onboard/login");
        } else {
          notifyUser("error", result?.message, "Validation Error");
        }
      });
    } else {
      notifyUser(
        "error",
        "Password must match all requirement",
        "Validation Error"
      );
    }
  };

  const submitChangePin = () => {
    if (isFormComplete(pinForm)) {
      if (pinForm.newPin !== pinForm.confirmNewPin) {
        return notifyUser(
          "error",
          "New PIN must match confirmation PIN",
          "Validation Error"
        );
      }
      toggleIsLoadingPin();
      serverRequest("PUT", "users/pin/change", pinForm).then((result) => {
        toggleIsLoadingPin();
        if (result?.success) {
          notifyUser(
            "success",
            "PIN changed successful. Login to affect changes!",
            "PIN Changed"
          );
          logout();
          navigate("/onboard/login");
        } else {
          notifyUser("error", result?.message, "Validation Error");
        }
      });
    } else {
      notifyUser("error", "All fields are required!", "Validation Error");
    }
  };

  const submitResetPin = () => {
    if (!isFormComplete(pinResetForm)) {
      return notifyUser(
        "error",
        "All fields are required!",
        "Validation Error"
      );
    }

    if (pinResetForm.newPin !== pinResetForm.confirmNewPin) {
      return notifyUser(
        "error",
        "New PIN must match confirmation PIN",
        "Validation Error"
      );
    }

    toggleIsLoadingPin();

    serverRequest(
      "POST",
      "users/pin/reset",
      {
        newPin: pinResetForm.newPin,
        confirmNewPin: pinResetForm.confirmNewPin,
      },
      true,
      pinResetForm.otp
    )
      .then((result) => {
        if (result?.success) {
          notifyUser(
            "success",
            "PIN reset successful. Login to affect changes!",
            "PIN Reset"
          );
          logout();
          navigate("/onboard/login");
        } else {
          notifyUser(
            "error",
            result?.message || "Something went wrong",
            "Validation Error"
          );
        }
      })
      .catch((error) => {
        console.error("PIN Reset Error:", error);
        notifyUser(
          "error",
          "An unexpected error occurred. Please try again.",
          "Error"
        );
      })
      .finally(() => toggleIsLoadingPin());
  };

  const triggerOTP = () => {
    serverRequest("POST", "users/pin/forgot")
      .then((result) => {
        if (!result?.success) {
          notifyUser("error", "Problem sending OTP to number!", "OTP");
        } else {
          notifyUser("success", `OTP sent`, "OTP");
        }
      })
      .catch((error) => {
        notifyUser("error", error.message, "Validation Error");
      });
  };

  const verifyOTPPInSent = () => {
    if (pinResetForm.otp === "")
      return notifyUser("error", "Please enter the OTP received", "Error");
    toggleIsLoadingPin();
    serverRequest("POST", "otp/verify", {}, true, pinResetForm.otp).then(
      (result) => {
        toggleIsLoadingPin();
        if (result?.success) {
          setIsVerifiedOTPPin(false);
        } else {
          notifyUser("error", result?.message, "Error");
        }
      }
    );
  };

  return (
    <div className="">
      <PatternBackground>
        <div className="mb-5">
          <h1 className="fw-bold mb-2">{profile?.name}</h1>
          <small className="">{profile?.phone}</small>
        </div>
      </PatternBackground>
      <div className="om-container">
        <div className="row">
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-3">
            <Spin spinning={isLoadingProfile}>
              <div className="shadow p-4 rounded bg-white">
                <p className="fw-bold mb-0 lead">Personal Information</p>
                <hr />
                <TwoTextCard
                  title={profile?.name ?? "N/A"}
                  subText="Full Name"
                />
                <TwoTextCard
                  title={profile?.phone ?? "N/A"}
                  subText="Phone Number"
                />
                <TwoTextCard title={profile?.email ?? "N/A"} subText="Email" />
                <TwoTextCard
                  title={profile?.position ?? "N/A"}
                  subText="Position"
                />
              </div>
            </Spin>
          </div>
          <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12 mb-3">
            <Spin spinning={isLoadingProfile}>
              <div className="shadow p-4 rounded bg-white mb-4">
                <p className="fw-bold mb-0 lead">Company Information</p>
                <hr />
                <div className="row mt-4">
                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <TwoTextCard
                      title={profile?.company?.companyName ?? "N/A"}
                      subText="Company Name"
                    />
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <TwoTextCard
                      title={profile?.company?.schemeType ?? "N/A"}
                      subText="Pension Type"
                    />
                  </div>
                </div>
              </div>
            </Spin>
            <div className="shadow p-4 rounded bg-white mb-4">
              <p className="fw-bold mb-0 lead">Password</p>
              <hr />
              <div className="row mt-4">
                <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                  <TwoTextCard
                    title="Change Password"
                    subText="Update password for your account"
                  />
                </div>
                <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                  <button
                    className="btn btn-white  float-end"
                    onClick={togglePasswordModal}
                  >
                    Update Password
                  </button>
                </div>
              </div>
            </div>
            <div className="shadow p-4 rounded bg-white mb-4">
              <p className="fw-bold mb-0 lead">PIN Setup</p>
              <hr />
              <div className="row mt-4">
                <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                  <TwoTextCard
                    title="Change PIN"
                    subText="Update pin for your account"
                  />
                </div>
                <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                  <button
                    className="btn btn-white  float-end"
                    onClick={toggleChangePINModal}
                  >
                    Update PIN
                  </button>
                </div>
              </div>
            </div>
            <div className="shadow p-4 rounded bg-white mb-4">
              <p className="fw-bold mb-0 lead">PIN Reset</p>
              <hr />
              <div className="row mt-4">
                <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                  <TwoTextCard
                    title="Reset PIN"
                    subText="Reset pin for your account"
                  />
                </div>
                <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                  <button
                    className="btn btn-white  float-end"
                    onClick={toggleResetPINModal}
                  >
                    Reset PIN
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ModalDialog
        isOpen={isPMOpen}
        title="Change Password"
        closeFn={togglePasswordModal}
      >
        <Spin spinning={isLoadingPassword}>
          <div className="mb-4">
            <omk-text-field
              label="Enter Old Password"
              value={passwordForm.oldPassword}
              type={passwordType}
              onInput={changePasswordHandler}
              name="oldPassword"
            >
              <omk-icon
                slot="trailing-icon"
                onClick={togglePasswordType}
                style={{ cursor: "pointer" }}
              >
                <i className="bi bi-eye-slash" />
              </omk-icon>
            </omk-text-field>
          </div>
          <div className="mb-4">
            <omk-text-field
              label="Enter New Password"
              value={passwordForm.password}
              type={passwordType}
              onInput={changePasswordHandler}
              name="password"
            >
              <omk-icon
                slot="trailing-icon"
                onClick={togglePasswordType}
                style={{ cursor: "pointer" }}
              >
                <i className="bi bi-eye-slash" />
              </omk-icon>
            </omk-text-field>
          </div>
          <div className="mb-4">
            <omk-text-field
              label="Confirm New Password"
              value={passwordForm.confirmPassword}
              type={passwordType}
              onInput={changePasswordHandler}
              name="confirmPassword"
            >
              <omk-icon
                slot="trailing-icon"
                onClick={togglePasswordType}
                style={{ cursor: "pointer" }}
              >
                <i className="bi bi-eye-slash" />
              </omk-icon>
            </omk-text-field>
          </div>
          <div>
            <div className="row mb-4 mt-4">
              <div className="col-6">
                <small
                  className={
                    criteria.minLength
                      ? "text-success float-start"
                      : "omk-text-secondary float-start"
                  }
                >
                  <i className="bi bi-check-lg" /> Min 8 characters
                </small>
                <br />
                <small
                  className={
                    criteria.hasUppercase
                      ? "text-success float-start"
                      : "omk-text-secondary float-start"
                  }
                >
                  <i className="bi bi-check-lg" /> An uppercase
                </small>
              </div>
              <div className="col-6">
                <small
                  className={
                    criteria.hasSpecialChar
                      ? "text-success float-start"
                      : "omk-text-secondary float-start"
                  }
                >
                  <i className="bi bi-check-lg" /> A special character
                </small>
                <br />
                <small
                  className={
                    criteria.hasNumber
                      ? "text-success float-start"
                      : "omk-text-secondary float-start"
                  }
                >
                  <i className="bi bi-check-lg" /> A number
                </small>
              </div>
            </div>
          </div>
          <button
            className="btn btn-primary mt-5 w-50 mobile-full-width"
            onClick={submitChangePassword}
          >
            save changes
          </button>
        </Spin>
      </ModalDialog>
      <ModalDialog
        isOpen={isCPOpen}
        title="Change PIN"
        closeFn={toggleChangePINModal}
      >
        <Spin spinning={isLoadingPin}>
          <div className="mb-4">
            <omk-otp-field
              number-of-inputs="4"
              resend-text=""
              resend-button-label=""
              label="Enter Old PIN"
              className="mb-4"
              value={pinForm.oldPin}
              name="oldPin"
              onInput={changePinHandler}
            />
          </div>
          <div className="mb-4">
            <omk-otp-field
              number-of-inputs="4"
              resend-text=""
              resend-button-label=""
              label="Enter New PIN"
              className="mb-4"
              value={pinForm.newPin}
              name="newPin"
              onInput={changePinHandler}
            />
          </div>
          <div className="mb-4">
            <omk-otp-field
              number-of-inputs="4"
              resend-text=""
              resend-button-label=""
              label="Confirm New PIN"
              className="mb-4"
              value={pinForm.confirmNewPin}
              name="confirmNewPin"
              onInput={changePinHandler}
            />
          </div>
          <button
            className="btn btn-primary mt-5 w-50 mobile-full-width"
            onClick={submitChangePin}
          >
            save changes
          </button>
        </Spin>
      </ModalDialog>
      <ModalDialog
        isOpen={isRPOpen}
        title="Reset PIN"
        closeFn={toggleResetPINModal}
      >
        <Spin spinning={isLoadingPin}>
          <div className="mb-4">
            <small>Enter OTP sent to {profile?.phone}</small>
            <omk-otp-field
              number-of-inputs="6"
              resend-text=""
              resend-button-label=""
              label="Enter OTP Sent"
              className="mb-4"
              onInput={changePinResetHandler}
              name="otp"
              value={pinResetForm.otp}
            />
          </div>
          {isVerifiedOTPPin ? (
            <button
              className="btn btn-primary mt-5 w-50 mobile-full-width"
              onClick={verifyOTPPInSent}
            >
              Verify OTP
            </button>
          ) : (
            ""
          )}
          {!isVerifiedOTPPin ? (
            <>
              <div className="mb-4">
                <omk-otp-field
                  number-of-inputs="4"
                  resend-text=""
                  resend-button-label=""
                  label="Enter New PIN"
                  className="mb-4"
                  onInput={changePinResetHandler}
                  name="newPin"
                  value={pinResetForm.newPin}
                />
              </div>
              <div className="mb-4">
                <omk-otp-field
                  number-of-inputs="4"
                  resend-text=""
                  resend-button-label=""
                  label="Confirm New PIN"
                  className="mb-4"
                  onInput={changePinResetHandler}
                  name="confirmNewPin"
                  value={pinResetForm.confirmNewPin}
                />
              </div>
              <button
                className="btn btn-primary mt-5 w-50 mobile-full-width"
                onClick={submitResetPin}
              >
                update
              </button>
            </>
          ) : (
            ""
          )}
        </Spin>
      </ModalDialog>

      <PopupModal
        isOpen={confirmModal}
        closeFn={toggleConfirmModal}
        title="Password updated successfully!"
        subTitle="Your password has been changed successfully. Keep it safe."
      />
    </div>
  );
};
